import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { TPagination } from 'modules/types';
import { Input } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons/lib';
import { CSSProperties } from 'styled-components';
import { PrimaryColor } from 'GlobalStyles';

type TSearchInputProps = {
  pagination: TPagination;
  reloadPage: (page: Partial<TPagination>) => void;
  placeHolder?: string;
  style?: CSSProperties;
  disabled?: boolean;
};

const SearchInput = ({
  pagination,
  reloadPage,
  placeHolder = '제목/내용',
  style,
  disabled = false,
}: TSearchInputProps) => {
  const [searchInputText, setSearchInputText] = useState(pagination.q);

  return (
    <Input
      size='large'
      disabled={disabled}
      placeholder={placeHolder}
      className='search-input'
      prefix={
        isEmpty(pagination.q) ? (
          <SearchOutlined />
        ) : (
          <CloseOutlined
            onClick={() => {
              setSearchInputText('');
              reloadPage({
                q: '',
              });
            }}
          />
        )
      }
      style={{
        ...style,
      }}
      value={searchInputText}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchInputText(e.currentTarget.value)}
      onPressEnter={(e: React.KeyboardEvent<HTMLInputElement>) => {
        reloadPage({
          current: 1,
          q: searchInputText,
        });
      }}
      suffix={
        <span
          onClick={() => {
            reloadPage({
              current: 1,
              q: searchInputText,
            });
          }}
          style={{
            cursor: 'pointer',
            fontSize: '14px',
            color: `${PrimaryColor}`,
          }}
        >
          검색
        </span>
      }
    />
  );
};

export default SearchInput;
